// Floating point number to percent string
// NOTE: does not contain percent symbol
// DEPRECATED replace module with ssf
export default function toPercent(value) {
  let round = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return `${(value * 100).toFixed(round).replace(/\.0+$/g, '')}`;
}